// The type and source are NOT really right, but this didn't seem the moment to introduce a new source and new type.
// There is a future ticket to make these dynamic, at which point we'll know better what source and type we can put
export const VIP_GROUP = { id: 'pfpt:vipusers', source: 'USER_CENTER', type: 'UserCenterGroup' };
export const VAP_GROUP = { id: 'pfpt:vapusers30days', source: 'USER_CENTER', type: 'UserCenterGroup' };

export const getGroupOptionDetails = (gr) => {
    if (gr.id.toLowerCase().startsWith(VIP_GROUP.id)) {
        return {
            label: 'VIP',
            icon: 'logo',
            info: 'VIP (Very Important People) group is defined in the TAP Dashboard.',
        };
    }
    if (gr.id.toLowerCase().startsWith(VAP_GROUP.id)) {
        return {
            label: 'VAP (Adaptive)',
            icon: 'logo',
            info: 'VAP (Very Attacked People) group is dynamically updated daily based on data '
                + 'from Proofpoint threat intelligence which can be viewed in the TAP Dashboard.'
        };
    }
    return {};
};
